module.exports = __webpack_public_path__ + "img/button.6d09f4b9.png";